module.exports = __webpack_public_path__ + "img/laminated.d5a0c9e.svg";